import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Carousel, CarouselItem, Col, Row } from 'reactstrap';

import './references.scss';

interface ReferencesComponentProps {
  references: any[];
}

interface ReferencesComponentState {
  activeIndex: number;
}

class ReferencesComponent extends Component<ReferencesComponentProps, ReferencesComponentState> {

  animating = false;

  constructor(props: any) {
    super(props);

    this.state = {activeIndex: 0};

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  next() {
    const {activeIndex} = this.state as any;
    const {references} = this.props as any;
    if (!this.animating) {
      const nextIndex = (activeIndex === references.length - 1) ? 0 : activeIndex + 1;
      this.setState({activeIndex: nextIndex});
    }
  }

  previous() {
    const {activeIndex} = this.state as any;
    const {references} = this.props as any;
    if (!this.animating) {
      const previousIndex = activeIndex === 0 ? references.length - 1 : activeIndex - 1;
      this.setState({activeIndex: previousIndex});
    }
  }

  goToIndex(newIndex: number) {
    if (!this.animating) {
      this.setState({activeIndex: newIndex});
    }
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  render() {
    return (
        <article role="references" id="references">
          <h2>References</h2>
          <Carousel
              activeIndex={this.state.activeIndex}
              next={this.next}
              previous={this.previous}
              interval={15000}
          >
            {this.props.references.map(this.renderSlide.bind(this))}
          </Carousel>
        </article>
    );
  }

  renderSlide(reference: any, index: number) {
    return (
        <CarouselItem
            onExiting={this.onExiting}
            onExited={this.onExited}
            key={`ref-${index}`}
        >
          <Row className="justify-content-center">
            <Col xs={12} md={3} className="text-center">
              <img src={reference.picture} alt=""/>
            </Col>
            <Col xs={12} md={8} className="ml-3 align-self-center">
              <h3>{reference.reference}</h3>
              <h5><a href={reference.linkedin} target="_blank">{reference.name}</a></h5>
            </Col>
          </Row>
        </CarouselItem>
    );
  }
}

const mapStateToProps = (state: any): ReferencesComponentProps => {
  return {
    references: state.cv.references || [],
  };
};

export default connect(mapStateToProps, null)(ReferencesComponent);



// WEBPACK FOOTER //
// ./src/components/references/references.component.tsx